export default __webpack_public_path__ + "static/media/12.7a22afa0.png";